document.addEventListener("DOMContentLoaded", function() {
  // Variable pour suivre le dernier clic
  let lastClickTime = 0;
  
  // Fonction principale qui initialise la barre de progression
  function initProgressBar() {
    const reviewsContainer = document.querySelector('#judgeme_product_reviews');
    if (!reviewsContainer) return;
    
    const containerSection = reviewsContainer.closest('.container');
    if (!containerSection) return;
    
    const sectionHeader = containerSection.querySelector('.section-header');
    if (!sectionHeader) return;
    
    // Vérifie si la barre de progression existe déjà, sinon la crée
    if (!sectionHeader.querySelector('.barre-progression')) {
      sectionHeader.insertAdjacentHTML("beforeend", '<div class="barre-progression"></div>');
    }
    
    const listeIngredients = reviewsContainer.querySelector('.jdgm-rev-widg__reviews');
    const barreProgression = sectionHeader.querySelector('.barre-progression');
    
    if (listeIngredients && barreProgression) {
      // Met à jour la barre de progression
      updateProgressBar();
      
      // Ajoute un événement de défilement pour mettre à jour la barre
      listeIngredients.removeEventListener('scroll', handleScroll);
      listeIngredients.addEventListener('scroll', handleScroll);
      
      // Ajoute un événement de redimensionnement pour mettre à jour la barre
      window.removeEventListener('resize', updateProgressBar);
      window.addEventListener('resize', updateProgressBar);
      
      function updateProgressBar() {
        const scrollWidth = listeIngredients.scrollWidth;
        const visibleWidth = listeIngredients.clientWidth;
        const scrollPosition = listeIngredients.scrollLeft;
        
        const visibleRatio = visibleWidth / scrollWidth;
        const minWidthPercentage = visibleRatio * 100;
        
        const scrollableWidth = scrollWidth - visibleWidth;
        const scrollProgressPercentage = scrollPosition / scrollableWidth;
        
        const finalWidth = minWidthPercentage + (scrollProgressPercentage * (100 - minWidthPercentage));
        
        barreProgression.style.setProperty('--progress-width', `${finalWidth}%`);
      }
      
      function handleScroll() {
        updateProgressBar();
        
        // Vérification si on est à la fin du scroll horizontal
        const scrollWidth = listeIngredients.scrollWidth;
        const visibleWidth = listeIngredients.clientWidth;
        const scrollPosition = listeIngredients.scrollLeft;
        
        // Marge de tolérance (5 pixels) pour considérer qu'on est à la fin
        const isAtEnd = scrollPosition + visibleWidth >= scrollWidth - 5;
        
        if (isAtEnd) {
          // Vérifie si suffisamment de temps s'est écoulé depuis le dernier clic
          const currentTime = Date.now();
          if (currentTime - lastClickTime >= 1000) { // 1000ms = 1 seconde
            // Cherche le bouton "Load More" et simule un clic
            const loadMoreBtn = document.querySelector("#judgeme_product_reviews .jdgm-paginate>a.jdgm-paginate__load-more");
            if (loadMoreBtn && !loadMoreBtn.classList.contains("jdgm-paginate__load-more--loading") && loadMoreBtn.style.display !== 'none') {
              loadMoreBtn.click();
              lastClickTime = currentTime; // Met à jour le temps du dernier clic
            }
          }
        }
      }
    }
  }
  
  // Première initialisation au chargement de la page
  let attempts = 10;
  const initialCheck = setInterval(() => {
    if (document.querySelector('#judgeme_product_reviews') || attempts <= 0) {
      clearInterval(initialCheck);
      initProgressBar();
    }
    attempts--;
  }, 500);
  
  // Observateur de mutation pour surveiller les changements dans la zone des avis
  const targetNode = document.body;
  const config = { childList: true, subtree: true };
  
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        const reviewsContainer = document.querySelector('#judgeme_product_reviews .jdgm-rev-widg__reviews');
        if (reviewsContainer) {
          // Réinitialise la barre de progression après un court délai
          // pour s'assurer que tout le contenu est chargé
          setTimeout(() => {
            initProgressBar();
          }, 100);
        }
      }
    }
  });
  
  // Commence à observer les changements dans le DOM
  observer.observe(targetNode, config);
  
  // Ajoute également des écouteurs d'événements pour les clics sur les boutons de pagination
  document.addEventListener('click', function(e) {
    if (e.target.closest('.jdgm-paginate__page')) {
      // Réinitialise la barre de progression après un court délai
      setTimeout(() => {
        initProgressBar();
      }, 300);
    }
  });




  const form = document.getElementById('cart_form');
  if (form) {
    const checkbox = document.getElementById('cart-drawer-terms-of-service');
    const label = document.querySelector('.checkbox-control label');
    const submitButton = form.querySelector('button[type="submit"]');

    // Vérifier que tous les éléments existent avant d'ajouter les événements
    if (checkbox && label && submitButton) {
      function updateLabelState() {
        if (checkbox.checked) {
          label.style.color = '';
        } else {
          label.style.color = 'red';
        }
      }

      checkbox.addEventListener('change', updateLabelState);

      submitButton.addEventListener('click', function(e) {
        if (!checkbox.checked) {
          e.preventDefault();
          label.style.color = 'red';
        }
      });
    }
  }

  
   // Fonction pour égaliser les hauteurs des paragraphes
   function equalizeMediaBlocksParagraphs() {
     // Vérifier si on est au-dessus de 700px
     if (window.innerWidth >= 700) {
       document.querySelectorAll('.shopify-section--media-blocks[id*="media_blocks_qdebcz"]').forEach(function(section) {
         const paragraphs = section.querySelectorAll('.max-w-sm p');
         let maxHeight = 0;
         
         // Reset des hauteurs
         paragraphs.forEach(function(paragraph) {
           paragraph.style.height = 'auto';
         });
         
         // Trouver la hauteur maximale
         paragraphs.forEach(function(paragraph) {
           const height = paragraph.offsetHeight;
           if (height > maxHeight) {
             maxHeight = height;
           }
         });
         
         // Appliquer la hauteur maximale à tous les paragraphes
         paragraphs.forEach(function(paragraph) {
           paragraph.style.height = maxHeight + 'px';
         });
       });
     } else {
       // Reset des hauteurs en mobile
       document.querySelectorAll('.shopify-section--media-blocks[id*="media_blocks_qdebcz"] .max-w-sm p').forEach(function(paragraph) {
         paragraph.style.height = 'auto';
       });
     }
   }
  
   // Exécuter au chargement
   equalizeMediaBlocksParagraphs();
   
   // Gérer le resize
   window.addEventListener('resize', function() {
     equalizeMediaBlocksParagraphs();
   });



  // Pop-up Newsletter de confirmation désactivé
  if (window.location.href.includes('?customer_posted=true') && !window.location.href.includes('newsletter-popup')) {
    const style = document.createElement('style');
    style.textContent = '.shopify-section.shopify-section-group-overlay-group.shopify-section--popup { display: none !important; }';
    document.head.appendChild(style);
    document.querySelector("html").classList.remove("lock");
  }

  // Enlever H2 Judgme
  const h2Element = document.querySelector('#judgeme_product_reviews .jdgm-rev-widg__title');
  if (h2Element) {
    h2Element.outerHTML = h2Element.outerHTML.replace('<h2', '<span').replace('</h2>', '</span>');
  }

  // Enlever section avis si vide
  var badge_avis = document.querySelector(".jdgm-prev-badge__stars");
  if ( badge_avis ){
    var note = badge_avis.getAttribute("data-score");
    if ( note == "0.00" || note == "0" ){
      document.querySelector('.shopify-section--apps[id*="judgme_me_section"]').remove();
    }
  }

  // Enlever section Comparaison si vide
  if (!!document.querySelector(".shopify-section--comparaisons") === true && !!document.querySelector(".shopify-section--comparaisons .comparaisons") === false){
    document.querySelector(".shopify-section--comparaisons").remove();
  }

  // Enlever section FAQ si vide
  if (!!document.querySelector(".shopify-section--faq:not(.shopify-section--description-detaillee)") === true && !!document.querySelector(".shopify-section--faq:not(.shopify-section--description-detaillee) .faq .accordion") === false){
    document.querySelector(".shopify-section--faq:not(.shopify-section--description-detaillee)").remove();
  }

  
  // Rafraîchir puis ouvrir le cart drawer quand on ajoute un produit depuis Quizify 
  window.addEventListener("quizifyAddToCart", function() {
    
    document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
    
    function openDrawerAfterRefresh() {
      const cartDrawer = document.querySelector("cart-drawer");
      if (cartDrawer) {
        cartDrawer.show();
      }
      document.removeEventListener("cart-drawer:refreshed", openDrawerAfterRefresh);
    }
    
    document.addEventListener("cart-drawer:refreshed", openDrawerAfterRefresh);
  });



  // Rendre draggable avis clients
  const reviewsContainer = document.querySelector('#judgeme_product_reviews .jdgm-rev-widg__reviews');

  if (reviewsContainer) {
    let isDown = false;
    let startX;
    let scrollLeft;
  
    reviewsContainer.addEventListener('mousedown', (e) => {
      isDown = true;
      reviewsContainer.style.cursor = 'grabbing';
      startX = e.pageX - reviewsContainer.offsetLeft;
      scrollLeft = reviewsContainer.scrollLeft;
    });
  
    reviewsContainer.addEventListener('mouseleave', () => {
      isDown = false;
      reviewsContainer.style.cursor = 'grab';
    });
  
    reviewsContainer.addEventListener('mouseup', () => {
      isDown = false;
      reviewsContainer.style.cursor = 'grab';
    });
  
    reviewsContainer.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - reviewsContainer.offsetLeft;
      const walk = (x - startX) * 1;
      reviewsContainer.scrollLeft = scrollLeft - walk;
    });
  }


  // Rendre draggable les ingrédients
  const ingredientsContainer = document.querySelector('.shopify-section--ingredients .liste-ingredients');

  if (ingredientsContainer) {
    let isDown = false;
    let startX;
    let scrollLeft;
  
    ingredientsContainer.addEventListener('mousedown', (e) => {
      isDown = true;
      ingredientsContainer.style.cursor = 'grabbing';
      startX = e.pageX - ingredientsContainer.offsetLeft;
      scrollLeft = ingredientsContainer.scrollLeft;
    });
  
    ingredientsContainer.addEventListener('mouseleave', () => {
      isDown = false;
      ingredientsContainer.style.cursor = 'grab';
    });
  
    ingredientsContainer.addEventListener('mouseup', () => {
      isDown = false;
      ingredientsContainer.style.cursor = 'grab';
    });
  
    ingredientsContainer.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - ingredientsContainer.offsetLeft;
      const walk = (x - startX) * 1;
      ingredientsContainer.scrollLeft = scrollLeft - walk;
    });
  }



  // Rendre les carousels multicolumn draggable
  const carousels = document.querySelectorAll('.shopify-section--multi-column scroll-carousel');
  
  carousels.forEach(carousel => {
    const originalScrollTo = carousel.scrollTo.bind(carousel);
    
    let isDragging = false;
    let dragEndPosition = null;
    
    carousel.addEventListener('mousedown', () => {
      isDragging = true;
    });
    
    carousel.addEventListener('touchstart', () => {
      isDragging = true;
    });
    
    carousel.addEventListener('mouseup', (e) => {
      if (isDragging) {
        dragEndPosition = carousel.scrollLeft;
      }
    });
    
    carousel.addEventListener('touchend', (e) => {
      if (isDragging) {
        dragEndPosition = carousel.scrollLeft;
      }
    });
    
    carousel.scrollTo = function(options) {
      if (isDragging && dragEndPosition !== null) {
        const cells = this.cells;
        const lastCell = cells[cells.length - 1];
        const currentScroll = dragEndPosition;
        const carouselWidth = this.clientWidth;
        
        const distanceToLastCell = lastCell.offsetLeft - currentScroll;
        
        if (distanceToLastCell < carouselWidth * 0.5 && distanceToLastCell > 0) {
          const targetScroll = lastCell.offsetLeft + lastCell.clientWidth - carouselWidth;
          isDragging = false;
          dragEndPosition = null;
          originalScrollTo({ left: Math.max(0, targetScroll), behavior: 'smooth' });
          return;
        }
        
        isDragging = false;
        dragEndPosition = null;
        return;
      }
      
      originalScrollTo.apply(this, arguments);
    };
  });

});











